var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBlack14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_2948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12498 9.91652C6.04821 9.91697 5.97211 9.90225 5.90104 9.87322C5.82997 9.84419 5.76532 9.80142 5.71082 9.74736C5.65614 9.69313 5.61275 9.62861 5.58313 9.55753C5.55352 9.48644 5.53827 9.4102 5.53827 9.33319C5.53827 9.25618 5.55352 9.17994 5.58313 9.10885C5.61275 9.03777 5.65614 8.97325 5.71082 8.91902L7.64165 6.99986L5.78665 5.06902C5.67801 4.95973 5.61702 4.81188 5.61702 4.65777C5.61702 4.50367 5.67801 4.35582 5.78665 4.24652C5.84088 4.19185 5.9054 4.14845 5.97648 4.11884C6.04757 4.08922 6.12381 4.07397 6.20082 4.07397C6.27783 4.07397 6.35407 4.08922 6.42515 4.11884C6.49624 4.14845 6.56076 4.19185 6.61498 4.24652L8.86665 6.57986C8.97353 6.6889 9.0334 6.8355 9.0334 6.98819C9.0334 7.14088 8.97353 7.28748 8.86665 7.39652L6.53332 9.72986C6.48096 9.7864 6.41792 9.83201 6.34783 9.86405C6.27774 9.89609 6.202 9.91392 6.12498 9.91652Z",
    fill: "#1B1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_2948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlack14);
export default __webpack_public_path__ + "static/media/icon_arrow_black_14.9cc2823c1a6bf2a96d6efd3c25e70960.svg";
export { ForwardRef as ReactComponent };